import './hashtag.js.coffee';# Added by Script
class AccountSettings.HashtagCollection extends Backbone.Collection
  baseUrl: '/keepcon/hashtag_searches_collection'
  model: AccountSettings.Hashtag

  initialize:(collectionUrlProvider)->
    @collectionUrlProvider = collectionUrlProvider

  getPage:(page)=>
    this.url = @collectionUrlProvider.url(page)
    this.fetch(
      success:(response, xhr)=> @onSuccess(response, xhr)
    )

  onSuccess:(response, xhr)=>
    hashtagSearches = xhr.hashtag_search
    @reset(hashtagSearches)
    @trigger('hashtag:collection:fetch:success', @, xhr.active_hashtags, xhr.total_pages)

  changeUrlProvider:(collectionUrlProvider)->
    @collectionUrlProvider = collectionUrlProvider
